import { isElementInViewport } from "utility/is-element-in-viewport"

const el = {
  root: document.querySelector<HTMLButtonElement>('.product-bar'),
  prices: document.querySelector<HTMLDivElement>('.product-info__price-container'),
}

export const ProductBar = {

  init: () => {
    if (!el.root || !el.prices) return
    window.addEventListener('scroll', ProductBar.onScroll)
  },

  onScroll: () => {
    const pricesAreInView = isElementInViewport(el.prices)

    if (!pricesAreInView) {
      el.root.classList.add('product-bar--visible')
      return
    }

    el.root.classList.remove('product-bar--visible')
  },
}